
import { Outlet, Navigate } from "react-router-dom";
import useAuthStore from "../store/authStore";

const ManagerRouteProtect = () => {
  const { refToken, isAuthenticated, userType } = useAuthStore();

  
  return refToken && isAuthenticated && userType === "manager" ? (
    <Outlet />
  ) : (
    <Navigate to={"/login"} />
  );
};
export default ManagerRouteProtect;


